var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"btn"}},[_c('ButtonDropdown',{attrs:{"id":"button-dropdown-kebab","icon":_vm.icon,"iconed":"","options":_vm.options,"width-full":false},on:{"id":function($event){return _vm.change($event)},"input":_vm.change}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }